import React from 'react';
import { Helmet } from 'react-helmet';
import { graphql } from 'gatsby';

const StructuredMarkup = ({
  headline,
  name,
  url,
  datePublished,
  articleBody,
  image,
  type,
  id,
}) => {
  let articleBodyString = articleBody;

  // Handle articleBody being rich text
  if (articleBody?.value) {
    const richText = articleBody.value;
    // Start from the root .content field
    // And start with an empty string that all the content.value fields can be appended to
    articleBodyString = recursiveRichTextToPlain(richText?.document, '');
  }

  const data = {
    '@context': 'http://schema.org',
    '@type': type,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': id,
    },
    headline,
    name,
    author: {
      website: 'https://litfibre.com/',
      '@type': 'Organization',
      name: 'Lit Fibre',
    },
    datePublished,
    articleBody: articleBodyString,
    url,
    publisher: {
      '@type': 'Organization',
      name: 'Lit Fibre',
    },
    image,
  };
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
};

const recursiveRichTextToPlain = (content, plainText) => {
  let result = plainText;

  // Iterate over content array
  content?.children.forEach((contentItem) => {
    // If the array item has the key field, append its value to the result

    contentItem?.children?.forEach((item) => {
      if (item.value) {
        // Check if we need a space after any previous text
        if (result.length > 0 && !result.endsWith(' ')) result += ' ';

        result += item.value;
      }

      // If the array item has the content field, call this function from itself (recursion), and append the resulting text to our result
      if (item.content) result = recursiveRichTextToPlain(item.content, result);
    });
  });

  return result;
};

export default StructuredMarkup;
